// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_a2-6";
export var headerCell = "_a2-2";
export var rowWrapper = "_a2-4";
export var table = "_a2-1";
export var virtualRowWrapper = "_a2-5";
export var virtualTableContainer = "_a2-0";
export var white = "_a2-3";